import React from 'react';
import Header from '../Components/Header';

const Learn = () => {
  return <Header>Learn</Header>;
};

export default Learn;
